import { useEvent as t } from "../events.js";
import { nearPair as e, theSamePair as o, near as n } from "../../utils/compare.js";
import { useBindProp as s } from "../props.js";
import { lngLat2Array as r, xy2Array as i } from "../../utils/convert.js";
import { Anchors as f } from "../../utils/types.js";
import m from "./overlay.js";
import l from "./zooms.js";

function u(u, p) {
  m(u, p), l(u, p), s(u, {
    getter: function getter(t) {
      return r(t.getPosition());
    },
    equals: e,
    setter: function setter(t, e) {
      t.setPosition(e);
    }
  }, p.position), s(u, {
    setter: "setTitle"
  }, p.title), s(u, {
    equals: o,
    setter: function setter(t, o) {
      if (o) {
        var n = i(t.getOffset());
        e(o, n) || t.setOffset(new window.AMap.Pixel(o[0], o[1]));
      }
    }
  }, p.offset), s(u, {
    setter: "setAnchor",
    validate: function validate(t) {
      return f.includes(t);
    }
  }, p.anchor), s(u, {
    equals: n,
    setter: "setAngle",
    getter: "getAngle"
  }, p.angle), t(u, "moving", p.onMoving), t(u, "moveend", p.onMoveEnd), t(u, "movealong", p.onMoveAlong);
}

export default u;